import { createTheme, PaletteColor } from "@mui/material";
import { COLORS } from "../constants/colors";

declare module "@mui/material/styles" {
  interface Palette {
    accent: PaletteColor;
  }
  interface PaletteOptions {
    accent: PaletteColor;
  }
}

declare module "@mui/material/LinearProgress" {
  interface LinearProgressPropsColorOverrides {
    accent: true;
  }
}

declare module "@mui/material/CircularProgress" {
  interface CircularProgressPropsColorOverrides {
    accent: true;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    accent: true;
  }
}

export const getLightTheme = () => {
  const { palette } = createTheme();

  return createTheme({
    typography: {
      htmlFontSize: 10,
      h1: {
        fontSize: 30,
        fontWeight: 500,
      },
      h2: {
        fontSize: 26,
        fontWeight: 400,
      },
      h3: {
        fontSize: 22,
      },
      h4: {
        fontSize: 20,
      },
      h5: {
        fontSize: 18,
      },
      h6: {
        fontSize: 16,
      },
      body1: {
        fontSize: 14,
      },
      body2: {
        fontSize: 14,
      },
    },
    palette: {
      primary: {
        main: COLORS.THEME_PRIMARY,
      },
      secondary: {
        main: COLORS.THEME_SECONDARY,
      },
      accent: palette.augmentColor({
        color: { main: COLORS.THEME_ACCENT },
      }),
    },
  });
};
